var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"sort-by":"biz_name","dense":"","mobile-breakpoint":"0","role":"button"},on:{"click:row":_vm.select},scopedSlots:_vm._u([{key:"item.last_visit",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(_vm._f("date")(item.last_visit,{ dynamic: true })))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }